module.exports = __webpack_public_path__ + "static/img/jinsei_no_rakuen_logo.67dc8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/jinsei_no_rakuen_logo.png
// module id = gadj
// module chunks = 0